var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21.75H15C15.375 21.75 15.75 21.4219 15.75 21V7.5H12C11.1562 7.5 10.5 6.84375 10.5 6V2.25H3C2.57812 2.25 2.25 2.625 2.25 3V21C2.25 21.4219 2.57812 21.75 3 21.75ZM3 0H10.7344C11.5312 0 12.2812 0.328125 12.8438 0.890625L17.1094 5.15625C17.6719 5.71875 18 6.46875 18 7.26562V21C18 22.6875 16.6406 24 15 24H3C1.3125 24 0 22.6875 0 21V3C0 1.35938 1.3125 0 3 0ZM5.625 12H12.375C12.9844 12 13.5 12.5156 13.5 13.125C13.5 13.7812 12.9844 14.25 12.375 14.25H5.625C4.96875 14.25 4.5 13.7812 4.5 13.125C4.5 12.5156 4.96875 12 5.625 12ZM5.625 16.5H12.375C12.9844 16.5 13.5 17.0156 13.5 17.625C13.5 18.2812 12.9844 18.75 12.375 18.75H5.625C4.96875 18.75 4.5 18.2812 4.5 17.625C4.5 17.0156 4.96875 16.5 5.625 16.5Z",
    fill: "#F4BA34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.d3917efe314a83c8a2e21010ac853ffd.svg";
export { ForwardRef as ReactComponent };